import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, Validators, NgForm } from '@angular/forms';
import { AtopicDermatitisAfterVideo3 } from 'src/app/models/atopic-dermatitis-after-video-3.model';
import { AtopicDermatitisAfterVideo3Service } from 'src/app/services/atopicDermatitisAfterVideo3.service';

@Component({
    selector: 'app-after-question-video-3-popup',
    templateUrl: './after-question-video-3-popup.component.html',
    styleUrls: ['./after-question-video-3-popup.component.scss'],
})
export class AfterQuestionVideo3PopupComponent {
    public atopicDermatitisAfterVideo3: AtopicDermatitisAfterVideo3;

    itemForm = this.fb.group({
        question1: ['', Validators.required],
        question2: ['', Validators.required],
        question3: ['', Validators.required],
        email: [''],
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) public data,
        public dialogRef: MatDialogRef<AfterQuestionVideo3PopupComponent>,
        private fb: FormBuilder,
        private atopicDermatitisAfterVideo3Service: AtopicDermatitisAfterVideo3Service
    ) {}

    onAtopicDermatitisChange(value) {
        this.itemForm.patchValue({});
    }

    // saveFaq() {
    //     this.faqService.updateFaq(this.faq);
    // }

    submit() {
        // this.isSubmitted = true;
        localStorage.setItem('isSubmitted', 'true');
        const a = { ...this.atopicDermatitisAfterVideo3, ...this.itemForm.value };
        this.atopicDermatitisAfterVideo3Service.saveAtopicDermatitisAfterVideo3(a);
        this.dialogRef.close();
    }

    cancel() {
        this.dialogRef.close();
    }

    submitForm(form: NgForm) {
        // this.isSubmitted = true;
        if (!form.valid) {
            return false;
        } else {
            alert(JSON.stringify(form.value));
        }
        this.dialogRef.close();
    }
}
